import BreadcrumbRightArrowSVG from "../../assets/icons/svg/BreadcrumbRightArrowSVG";
import { FontEnum } from "../../utils/enums/FontEnum";
import { useNavigate, useLocation } from "react-router-dom";


/*
type Breadcrumb = {
    title: string;
    href: string;
};

breadcrumbs: Breadcrumb[];
*/

const Breadcrumb = ({
    title,
    breadcrumbs,
    BesideTitleComponent,
    EndComponent
}) => {

    const location = useLocation();
    const navigate = useNavigate();


    const handleBreadcrumbClick = (href) => {
        if (href === location.pathname) {
            window.location.reload();
        } else {
            navigate(href);
        }
    };



    const GetActionBreadcrumb = (crumb, index) => {
        return (
            <div
                key={index}
                style={styles.breadcrumbContainer}
            >
                <p
                    style={styles.crumbTitle}
                    onClick={() => handleBreadcrumbClick(crumb.href)}

                >
                    {crumb.title}
                </p>

                <BreadcrumbRightArrowSVG />
            </div>
        );
    };

    const GetInfoBreadcrumb = (crumb, index) => {
        return (
            <div
                key={index}
                style={styles.breadcrumbContainer}
            >

                <p style={styles.lastCrumbTitle}>
                    {crumb.title}
                </p>
            </div>
        );
    };


    const lastIndex = breadcrumbs.length - 1;

    return (
        <div style={styles.mainContainer}>
            <div style={styles.breadcrumbsContainer}>

                <div style={styles.titleAndBesideComponentContainer}>
                    <p style={styles.titleText}>
                        {title}
                    </p>


                    {BesideTitleComponent && (
                        <BesideTitleComponent />
                    )}

                </div>

                <div style={styles.breadcrumbMainContainer}>
                    {breadcrumbs.map((crumb, index) => {
                        return (index !== lastIndex)
                            ? GetActionBreadcrumb(crumb, index)
                            : GetInfoBreadcrumb(crumb, index)
                    })}
                </div>
            </div>


            {EndComponent && (
                <EndComponent />
            )}

        </div>
    );
};

export default Breadcrumb;

const styles = {
    mainContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    breadcrumbsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    titleAndBesideComponentContainer: {
        display: 'flex',
        width: 'max-content',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
    },
    titleText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "34px",
        fontWeight: 400,
        color: "rgba(0,0,0,0.87)",
        lineHeight: "42px"
    },
    breadcrumbMainContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
    },
    breadcrumbContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
    },
    crumbTitle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        cursor: 'pointer'
    },
    lastCrumbTitle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "rgba(0,0,0,0.6)"
    }
};